import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";

const HeaderRobotsBtn = () => {
  return (
    <Link to={"/messages/2/09900000000"} className="header-btn">
      <ReactSVG
        src={`${process.env.PUBLIC_URL}/assets/images/icons/robot.svg`}
      />
    </Link>
  );
};

export default HeaderRobotsBtn;
